import { useCallback, useEffect, useRef, useState } from 'react';
import { intercomService } from 'modules/taboola-common-frontend-modules/intercom';

export const useIntercomMenu = () => {
    const [active, setActive] = useState(false);
    const toggle = useCallback(() => {
        intercomService.toggle();
    }, []);
    const close = useCallback(() => {
        intercomService.hide();
    }, []);
    const intercomIconHiddenRef = useRef();

    if ((!intercomIconHiddenRef.current || !intercomService.getIconHidden()) && intercomService.isServiceBooted()) {
        intercomService.hideIcon();
        intercomIconHiddenRef.current = true;
    }

    useEffect(
        () =>
            intercomService.onShow(() => {
                setActive(true);
            }),
        []
    );

    useEffect(
        () =>
            intercomService.onHide(() => {
                setActive(false);
            }),
        []
    );

    return {
        toggle,
        close,
        active,
    };
};
